module.exports = __webpack_public_path__ + "img/22_61.21ceacb0.png";